import React, { ReactNode, useEffect, useReducer } from "react";
import { Box, CircularProgress, LinearProgress, Skeleton, styled, Typography } from "@mui/material";
import LoaderReducer from "../Shared-ui/Store/LoadingReducer/LoaderReducer";
import { StopLoading } from "../Shared-ui/Store/LoadingReducer/LoaderActions";
import { useSelector } from "react-redux";


interface MyComponentProps {
  children?: ReactNode; // Ensure you define children prop type
}


const FullPageSkeleton = styled(Box)(({ theme }) => ({
  position: 'fixed', // Make the skeleton loader cover the full page
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.7)', // Optional, for slight overlay effect
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999, // Ensures it's above other content
}));

const Loader: React.FC<MyComponentProps> = ({ children }) => {
  const payload = useSelector((state: any) => state.LoaderReducer);

  return (<>
    {children}

    {payload.isLoading && <>
      <FullPageSkeleton>
        <Box position="relative" display="inline-flex">
          <CircularProgress size={80} thickness={5} />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              variant="caption"
              component="div"
              color="textSecondary"
            >
             {payload.message || "Loading..."}
            </Typography>
          </Box>
        </Box>
      </FullPageSkeleton>
    </>}
  </>
  )
};

export default Loader